import React from 'react';
import SearchPage from './SearchPage';
import { fetchSearchPage } from '../../utils/lib';
import ListItemWAvatar from '../../layouts/ListItemWAvatar';
import { Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SearchUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  
  const renderItem = (item) => (
    <Box
      sx={{
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleOnClick(item)}
    >
      <ListItemWAvatar 
        key={item.id} 
        primary={item.name}
        secondary={item.email}
        />
    </Box>
  );

  const handleOnClick = async (user) => {
    const from = location.state?.from;
    navigate(from, { state: { user }, replace: true });
  };

  return (
    <SearchPage
      fetchFunction={fetchSearchPage}
      table={'users'}
      renderItem={renderItem}
      placeholder={t('search.searchUser')}
    />
  );
};

export default SearchUser;